import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpRoomSeat implements ICommand
{

	public ReturnCode : number = 0;
	public HostID : number = 0;
	public PlayerID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ReturnCode = ba.readUint53();
		this.HostID = ba.readUint16();
		this.PlayerID = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.ReturnCode);
		ba.writeUint16(this.HostID);
		ba.writeUint53(this.PlayerID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpRoomSeat();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ReturnCode(Q)='+this.ReturnCode+' ';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'PlayerID(Q)='+this.PlayerID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50125;
	}

	public getCmdName() : string
	{
		return 'SpRoomSeat';
	}

}
